module.exports = __webpack_public_path__ + "img/Payangel_Business_main.72f165bb.svg";